<template>
    <div class="reward-cover-wrapper">
      <a :href="goto" :target="gotoTarget">
        <div class="bg-img" :class="{'is-show-bg': bgShown}">
          <div class="reward-cover-box">
            <el-image            
                class="maisui"
                :src="require('@/assets/img/maisui-l.png')"
                fit="contain"></el-image>
            <div class="title-box">
                <div class="title" v-html="title" :style="titleStyle"></div>
                <el-image      
                    class="star-line"      
                    :src="require('@/assets/img/star-line.png')"
                    fit="contain"></el-image>
            </div>
            <el-image          
                class="maisui"  
                :src="require('@/assets/img/maisui-r.png')"
                fit="contain"></el-image>
          </div>        
        </div>
      </a>
    </div>
  </template>
  
  <script>   
  
    export default {
      components: { },
      props: {
        title: null,
        bgShown: false,
        titleStyle: null,
        goto: null,
        openType: null,
      },
      data() {
          return {
            gotoTarget: '_self'
          };
        },
      methods: {
        handleCoverClick(){
          if(this.goto != null){
            this.$router.push({
              path: this.goto,
            });
          }
        }
      },
      created() {
        this.gotoTarget = this.openType;
        if(this.gotoTarget == null || this.gotoTarget == undefined){
          this.gotoTarget = '_self';
        }
      },
      mounted() {}
    };
  </script>
  
  <style scoped>
    .reward-cover-wrapper{
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;   
      background: linear-gradient(90deg, #815119 0%, #B98F66 100%);  
      box-sizing: border-box;     
      width: 100%;
      min-height: 100%;     
      cursor: pointer;   
    }
    .reward-cover-wrapper:hover{
      opacity: 0.9;
    }
    .bg-img{
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;   
    }
    .is-show-bg{
      background: url('~@/assets/img/bg-reward-cover.png') no-repeat;
      background-size: 90% auto;
      background-position: center 30px;
    }
    .reward-cover-box{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 10px;
        gap: 10px;        
        box-sizing: border-box;
    }
    .title-box{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px;
        
    }

    .title{        
        text-align: center;
        letter-spacing: 0.1em;
        background: linear-gradient(180deg, #FFFBED 0%, #F9E29C 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;        
    }    

    /deep/.title p{
        margin-block-start: 5px !important;
        margin-block-end: 5px !important;        
        text-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.6);
    }

    .maisui{
        height: 70%;
    }
    .star-line{
        height: 17px;
    }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/basic/rewardcover/index.vue